import DefaultAPIErrorHandler from '@rover/react-lib/src/apis/DefaultAPIErrorHandler';
import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';

async function get<T>(
  url: string,
  errorMessage: string,
  checkForNotFoundStatus = false
): Promise<T | null> {
  const ai = getAxiosInstance();

  try {
    const response = await ai.get<Snakeify<T>>(url);

    if (response && response.status === 204) {
      return null;
    }

    return camelize(response.data, true) as T;
  } catch (e: any) {
    if (checkForNotFoundStatus) {
      const { response } = e;

      if (response && response.status === 404) {
        return null;
      }
    }

    throw DefaultAPIErrorHandler(e, errorMessage);
  }
}

export default get;
export { get };
